module.exports = __webpack_public_path__ + "img/shopify.d55cb92f.jpg";